export enum DxDiagnosisResultMaturityEnum {
  DX_PRELIMINARY = 'DX_PRELIMINARY', // DX予備層
  DX_READY = 'DX_READY', // DXレディ層
  DIGITALIZATION = 'DIGITALIZATION', // デジタライゼーション層
  DX_CHALLENGE = 'DX_CHALLENGE', // DXチャレンジ層
}
